export default __webpack_public_path__ + "static/media/Abbas.dc444a82.png";